import { getPlanInfoForPlanKind } from "@glide/common-core/dist/js/billing-vnext/org-plan-lib";
import type { Subscription } from "@glide/common-core/dist/js/billing-vnext/subscriptions";

export function getPlanInfoForSubscription(subscription: Subscription) {
    return getPlanInfoForPlanKind(subscription.plan);
}
